export default {
    path: "agent",
    name: "card-plugin-agent",
    redirect: "/card/plugin/agent/manage",
    component:()=>import("@/view/card/plugin/agent"),
    children: [
        {
            path: "manage",
            name: "card-plugin-agent-manage",
            component: () => import("@/view/card/plugin/agent/manage"),
            meta: {
                title: "代理管理"
            }
        },
        {
            path: "rule",
            name: "card-plugin-agent-rule",
            component: () => import("@/view/card/plugin/agent/rule"),
            meta: {
                title: "代理规则"
            },
        },
    ],
}